
import roles from "./userRoles"

module.exports = Object.freeze({
    USER_MAINTENANCE: [roles.PORTAL_ADMIN],
});



// WEBPACK FOOTER //
// ./client/app/_helpers/accessRules.js